/* eslint-disable */
/* @flow */

import React, { Component} from 'react'
import { TouchableOpacity } from 'react-native'

import styles from './Styles/CellStyles'
// create a component
class Cell extends Component {
    render() {
        const {
            backgroundColor,
            children,
            onPress,
            separator = false,
        
        } = this.props
        const containerStyles = [
            { backgroundColor: backgroundColor || 'white' },
        ]
    
        if (separator) {
            containerStyles.push(styles.separator)
        }
    
        return (
            <TouchableOpacity
                disabled={!onPress}
                onPress={onPress}
                style={containerStyles}>
                {children}
            </TouchableOpacity>
        )
    }
}

export default Cell
